import IconDashboard from '@/components/icons/IconDashboard.vue';
import IconIssue from '@/components/icons/IconIssue.vue';
import IconReports from '@/components/icons/IconReports.vue';
import IconSources from '@/components/icons/IconSources.vue';
import IconBell from '@/components/icons/IconBell.vue';
import IconBoardMembers from '@/components/icons/IconBoardMembers.vue';
import IconSettings from '@/components/icons/IconSettings.vue';
import IconPortalExternal from '@/components/icons/IconPortalExternal.vue';
export const NAV_ITEMS = [
    { id: 'dashboard', label: 'Dashboard', to: { name: 'dashboard' }, path: '/dashboard', icon: IconDashboard, section: 'monitoring' },
    { id: 'issues', label: 'Issues', to: { name: 'issues' }, path: '/issues', icon: IconIssue, section: 'monitoring', badge: 'open-issues' },
    { id: 'reports', label: 'Reports', to: { name: 'reports' }, path: '/reports', icon: IconReports, section: 'monitoring' },
    { id: 'sources', label: 'Sources', to: { name: 'sources' }, path: '/sources', icon: IconSources, section: 'configure', badge: 'sources-enabled' },
    { id: 'alert-rules', label: 'Alert rules', to: { name: 'alert-rules' }, path: '/alert-rules', icon: IconBell, section: 'configure' },
    { id: 'board-members', label: 'Board members', to: { name: 'board-members' }, path: '/board-members', icon: IconBoardMembers, section: 'configure' },
    { id: 'settings', label: 'Settings', to: { name: 'settings' }, path: '/settings', icon: IconSettings, section: 'configure' },
];
export const SECTION_LABELS = {
    monitoring: 'Monitoring',
    configure: 'Configure',
    public: 'Public',
};
/**
 * The portal entry is special — its target depends on the user's HOA slug,
 * resolved at render time from `useAuth().me.hoaSlug`. Returning null hides
 * the link entirely (the sidebar omits the item from the Public section).
 */
export function buildPortalNavItem(hoaSlug) {
    if (!hoaSlug)
        return null;
    return {
        id: 'portal',
        label: 'Resident portal',
        to: { name: 'portal', params: { slug: hoaSlug } },
        path: `/portal/${hoaSlug}`,
        icon: IconPortalExternal,
        section: 'public',
        external: true,
    };
}
